import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgPlay(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M1.2 23a.2.2 0 00.108-.032l16.8-10.798a.2.2 0 000-.338l-16.8-10.8a.197.197 0 00-.204-.006A.2.2 0 001 1.2v21.6a.198.198 0 00.2.2z",
    stroke: "inherit",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }));
}
const MemoSvgPlay = React.memo(SvgPlay);
export default MemoSvgPlay;